import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { CountryDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-country-view',
  templateUrl: './country-view.component.html',
  styleUrls: ['./country-view.component.css'],
})
export class CountryViewComponent implements OnInit {
  @Input() countries: CountryDto[];
  countryForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<CountryDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedCountry: any;
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.countryForm = this.fb.group({ Countries: this.fb.array([]) });
    this.setCountry();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display countries
  setCountry() {
    const control = this.countryForm.controls.Countries as FormArray;
    this.countries.forEach((e) => {
      control.push(
        this.fb.group({
          CountryName: e.CountryName,
          CountryCode: e.CountryCode,
          id: e.id,
        })
      );
    });
  }

  // method to add Country
  addCountry() {
    const control = this.countryForm.controls.Countries as FormArray;
    control.insert(
      0,
      this.fb.group({
        CountryName: ['', Validators.required],
        CountryCode: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteCountry(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.countryForm.controls.Countries as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.countries.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.countries[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'country';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('country');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
